<template>
    <div class="all-header">
        <div style="overflow: hidden;position: absolute; left:5px">
            <!-- 图标&&图图标字体 -->
            <span v-for="item in leftIcon" :key="item.id">
                <i :class="item.icon" :title="item.title"></i>
                <span>{{ item.textVal }}</span>
            </span>
        </div>
        <div class="w-100" style="text-align: center;">
            {{ middleText }}
        </div>
        <div style="position: absolute; right:5px">
            <!-- 图标字体 -->
            <i
                v-for="item in rightIcon"
                :key="item.id"
                :class="item.icon"
                :title="item.title"
                @click="
                    () => {
                        (item.click ? item.click.bind($parent) : () => {})();
                    }
                "
            ></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        leftIcon: {
            type: Array,
            default: () => []
        },
        rightIcon: {
            type: Array,
            default: () => []
        },
        middleText: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleClick(item) {
            this.$emit('handleClick', item);
        }
    }
};
</script>

<style lang="scss" scoped>
.all-header {
    height: 40px;
    width: 100%;
    padding: 5px;
    border-bottom: 1px solid #cccccc;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    i {
        margin-left: 5px;
        cursor: pointer;
    }
}
</style>
